import { useSocketStore } from '@/stores/socket';
import { useSocketStoreStock } from '@/stores/socket';
export default {
  data() {
    return {
      socketStore: useSocketStore(),
      socketStoreStock: useSocketStoreStock()
    };
  }
};
